import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Notify from "../../../Notify";
import { getData, postData, putData } from "../../../../services/library";
import moment from "moment/moment";
import { v4 as uuidv4 } from "uuid";
import { UrlApi } from "../../../../services/apirest";

function AsignarPedido(props) {
  const [choferes, setChoferes] = useState();
  const [choferSeleccionado, setChoferSeleccionado] = useState("");
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [datosformulario, setDatosformulario] = useState(props.dataPedido);
  const [disabled, setDisabled] = useState(false);
  const [checked, setChecked] = useState(false);
  const [repartoTarde, setRepartoTarde] = useState(false);
  const [rendicion, setRendicion] = useState([]);
  const [mostrarAdvertencia, setMostrarAdvertencia] = useState(false);
  const [uuidRendicion, setUuidRendicion] = useState(uuidv4());
  const [tieneExtendidas, setTieneExtendidas] = useState(false);
  const [verificandoExtendidas, setVerificandoExtendidas] = useState(false);
  const [rendicionExtendida, setRendicionExtendida] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Cambiar a false
  const [loadingBackdrop, setLoadingBackdrop] = useState(false); // Nuevo estado

  const limpiarRendiciones = () => {
    setRendicion([]);
    setRendicionExtendida([]);
    setTieneExtendidas(false);
    setMostrarAdvertencia(false);
    setUuidRendicion(uuidv4());
  };

  const obtenerRendicion = async () => {
    try {
      const response = await fetch(
        `${UrlApi}/envasado_rendiciones/choferxfecha/${choferSeleccionado.id}/${moment(datosformulario.fecha_para, "DD-MM-YYYY HH:mm").format("YYYY-MM-DD")}`,
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error obteniendo rendición:", error);
      return [];
    }
  };

  const verificarRendicionesExtendidas = async (choferId) => {
    if (!choferId) return false;

    try {
      const response = await fetch(
        `${UrlApi}/envasado_rendiciones/hayextendidas/${choferId}`,
      );
      const data = await response.json();

      if (data && data.length > 0) {
        setTieneExtendidas(true);
        setRendicionExtendida(data);
        return data;
      } else {
        setTieneExtendidas(false);
        return [];
      }
    } catch (error) {
      console.error("Error verificando rendiciones extendidas:", error);
      setTieneExtendidas(false);
      return [];
    }
  };

  useEffect(() => {
    if (Object.keys(choferSeleccionado).length !== 0) {
      setVerificandoExtendidas(true);

      const fetchData = async () => {
        try {
          // Esperar ambas peticiones
          const [rendicionData, extendidasData] = await Promise.all([
            obtenerRendicion(),
            verificarRendicionesExtendidas(choferSeleccionado.id),
          ]);

          setRendicion(rendicionData || []);
          if (extendidasData && extendidasData.length > 0) {
            setRendicionExtendida(extendidasData);
          }
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setVerificandoExtendidas(false);
        }
      };

      fetchData();
    }
  }, [choferSeleccionado, repartoTarde]);

  useEffect(() => {
    getData(
      "/choferes/envasadoxsucauth/" + localStorage.getItem("suc_auth").split(","),
      setChoferes,
    );
  }, []);

  async function guardarChoferAsignado(e) {
    setDisabled(true);
    e.preventDefault();
    setLoadingBackdrop(true);

    try {
      const fechaFormateada = moment(
        datosformulario.fecha_para,
        "DD-MM-YYYY HH:mm",
      ).format("YYYY-MM-DD");

      // Obtener datos actualizados
      const rendicionNormal = await obtenerRendicion();
      const rendicionExtendidaData = await verificarRendicionesExtendidas(
        choferSeleccionado.id,
      );

      let uuidSeleccionado;

      // Prioridad: 1. Rendición normal, 2. Rendición extendida, 3. Crear nueva
      if (rendicionNormal && rendicionNormal.length > 0) {
        // Caso 1: Tiene rendición normal
        uuidSeleccionado = rendicionNormal[0].uuid;

        // Actualizar pedido
        await putData(
          e,
          "/envasado_pedidos/" + datosformulario.id,
          {
            id_chofer: choferSeleccionado.id,
            estado: 246,
            uuid_rendicion: uuidSeleccionado,
            fecha_asignado: moment().format("YYYY-MM-DD HH:mm:ss"),
            asignado_por: localStorage.getItem("user"),
          },
          setNotificacion,
        );
      } else if (rendicionExtendidaData && rendicionExtendidaData.length > 0) {
        // Caso 2: No tiene rendición normal pero tiene extendida
        uuidSeleccionado = rendicionExtendidaData[0].uuid;

        // Actualizar pedido
        await putData(
          e,
          "/envasado_pedidos/" + datosformulario.id,
          {
            id_chofer: choferSeleccionado.id,
            estado: 246,
            uuid_rendicion: uuidSeleccionado,
            fecha_asignado: moment().format("YYYY-MM-DD HH:mm:ss"),
            asignado_por: localStorage.getItem("user"),
          },
          setNotificacion,
        );
      } else {
        // Caso 3: No tiene ninguna rendición, crear nueva
        uuidSeleccionado = uuidRendicion;

        // Actualizar pedido
        await putData(
          e,
          "/envasado_pedidos/" + datosformulario.id,
          {
            id_chofer: choferSeleccionado.id,
            estado: 246,
            uuid_rendicion: uuidSeleccionado,
            fecha_asignado: moment().format("YYYY-MM-DD HH:mm:ss"),
            asignado_por: localStorage.getItem("user"),
          },
          setNotificacion,
        );

        // Crear nueva rendición
        await postData(
          e,
          "/envasado_rendiciones/",
          {
            fecha: fechaFormateada,
            chofer: choferSeleccionado.id,
            uuid: uuidSeleccionado,
            activo: 1,
            estado: 272,
            sucursal:choferSeleccionado.id_sucursal
          },
          setNotificacion,
        );
      }

      // Cerrar diálogo después de guardar
      setTimeout(() => {
        props.setOpen(false);
      }, 1500);
    } catch (error) {
      console.error("Error guardando:", error);
      setNotificacion({
        open: true,
        mensaje: "Error al guardar: " + error.message,
        severity: "error",
        color: "error",
      });
    } finally {
      setLoadingBackdrop(false);
    }
  }

  useEffect(() => {
    if (
      rendicion.length === 0 &&
      rendicionExtendida.length === 0 &&
      Object.keys(choferSeleccionado).length !== 0
    ) {
      setMostrarAdvertencia(true);
    } else {
      setMostrarAdvertencia(false);
    }
  }, [rendicion, rendicionExtendida, choferSeleccionado]);

  const handleChoferChange = (event, value) => {
    limpiarRendiciones();
    setChoferSeleccionado(value);
  };

  const formatearFecha = (fecha) => {
  if (!fecha) return "No disponible";
  return moment(fecha).format("DD/MM/YYYY HH:mm");
};

const InformacionRendicion = ({ rendicion, titulo }) => {
  if (!rendicion || rendicion.length === 0) return null;
  
  const rend = rendicion[0];
  
  return (
    <Grid item xs={12}>
      <Box 
        sx={{ 
          bgcolor: '#e8f4f8', 
          p: 2, 
          borderRadius: 2,
          border: '1px solid #b0d4e8',
          mb: 2
        }}
      >
        <Typography variant="subtitle2" color="primary" gutterBottom>
          {titulo || "Rendición existente"}
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption" color="textSecondary">
              N° Rendición:
            </Typography>
            <Typography variant="body2">
              {rend.nro_rendicion || "No asignado"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="textSecondary">
              Fecha:
            </Typography>
            <Typography variant="body2">
              {formatearFecha(rend.fecha)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="textSecondary">
              Hora Salida:
            </Typography>
            <Typography variant="body2">
              {rend.hora_salida || "No registrada"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="textSecondary">
              KM Inicial:
            </Typography>
            <Typography variant="body2">
              {rend.km_inicial || "---"} km
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
    </Grid>
  );
};

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.setOpen(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingBackdrop}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress color="primary" />
          <Typography sx={{ mt: 2, color: "white" }}>
            Procesando asignación...
          </Typography>
        </Box>
      </Backdrop>

      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="sm"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Asignar Pedido {datosformulario.id} a Chofer
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent>
          <Grid container spacing={1}>
            {mostrarAdvertencia === true ? (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#fff9c4",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                }}
              >
                <label>
                  Se creara una rendición para el chofer{" "}
                  {choferSeleccionado.nombre_apellido} en el día{" "}
                  {moment(
                    datosformulario.fecha_para,
                    "DD-MM-YYYY HH:mm",
                  ).format("DD-MM-YYYY")}
                </label>
              </Grid>
            ) : null}
            {verificandoExtendidas && (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#e3f2fd",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <CircularProgress size={20} />
                <label>Verificando rendiciones existentes...</label>
              </Grid>
            )}

            {!verificandoExtendidas && choferSeleccionado && (
      <>
        {rendicion && rendicion.length > 0 && (
          <InformacionRendicion 
            rendicion={rendicion} 
            titulo="Rendición activa del día"
          />
        )}
        
        {rendicionExtendida && rendicionExtendida.length > 0 && rendicion.length === 0 && (
          <InformacionRendicion 
            rendicion={rendicionExtendida} 
            titulo="Rendición extendida disponible"
          />
        )}
      </>
    )}

            <Grid item xs={12}>
              <Autocomplete
                disabled={!choferes}
                required
                disableClearable
                id="chofer"
                size="small"
                noOptionsText={"Chofer INEXISTENTE"}
                options={choferes}
                autoHighlight
                getOptionLabel={(chofer) =>
                  chofer.id + "-" + chofer.nombre_apellido
                }
                onChange={handleChoferChange}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre_apellido}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Chofer"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            mt={1}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="contained"
              onClick={() => props.setOpen(false)}
              color="error"
              disabled={loadingBackdrop}
            >
              Volver
            </Button>
            <Button
              disabled={
                !choferSeleccionado ||
                verificandoExtendidas ||
                loadingBackdrop ||
                disabled
              }
              variant="contained"
              onClick={guardarChoferAsignado}
              color="success"
            >
              {loadingBackdrop ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Guardar"
              )}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AsignarPedido;
